import React, { useState } from 'react';
import CategoryForm from './CategoryForm';
import CategoryItem from './CategoryItem';

const CategoryManager = ({ categories, onAddCategory, onUpdateCategory, onDeleteCategory }) => {
  const [showForm, setShowForm] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);

  const handleSubmit = (categoryData) => {
    if (editingCategory) {
      onUpdateCategory(editingCategory.name, categoryData);
    } else {
      onAddCategory(categoryData);
    }
    setShowForm(false);
    setEditingCategory(null);
  };

  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-bold text-gray-800">Categorías</h3>
        <button
          onClick={() => {
            setEditingCategory(null);
            setShowForm(true);
          }}
          className="px-3 py-1 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm"
        >
          + Nueva
        </button>
      </div>

      {showForm && (
        <div className="mb-6">
          <CategoryForm
            category={editingCategory}
            onSubmit={handleSubmit}
            onCancel={() => {
              setShowForm(false);
              setEditingCategory(null);
            }}
          />
        </div>
      )}

      <div className="space-y-3">
        {categories.map(category => (
          <CategoryItem
            key={category.name}
            category={category}
            onEdit={(cat) => {
              setEditingCategory(cat);
              setShowForm(true);
            }}
            onDelete={onDeleteCategory}
          />
        ))}
      </div>
    </div>
  );
};

export default CategoryManager;